import { action } from 'easy-peasy';
import { IActionSetDefaultClient, IClientOptionByTeam } from '../types';
import extractFullName from '~/utils/text/extractFullName';

const setDefaultClient: IActionSetDefaultClient = action((state, payload) => {
  state.defaultClient = payload;

  const clientOption = state.clientOptionsByTeam.list?.find(item => item.id === payload?.id);
  if (payload && !clientOption) {
    const defaultClientOption: IClientOptionByTeam = {
      id: payload.id,
      name: extractFullName(payload),
      teams: payload.actTeams.map(t => ({
        id: t.team.id,
        name: t.team.name,
        isPrimary: t.isPrimary,
        isArchived: t.isArchived,
      })),
      photo: '',
      photoThumbnail: '',
      firstName: payload.firstName,
      lastName: payload.lastName,
    };

    state.clientOptionsByTeam.list = [...state.clientOptionsByTeam.list, defaultClientOption];
  }
});

export default setDefaultClient;
